import MainFiltersBQ from "../../../../Global/Models/Filters/MainFiltersBQ";

export default class EventGameRankingsFilters extends MainFiltersBQ {}
